/* eslint-disable max-len */
import React from 'react';

export default (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M11 22H13C16.7712 22 18.6569 22 19.8284 20.8284C21 19.6569 21 17.7712 21 14V12.6965C21 10.7195 21 9.73101 20.5724 8.88208C20.1447 8.03314 19.3504 7.44476 17.7618 6.26802L16.7618 5.52728C14.4674 3.82767 13.3201 2.97787 12 2.97787C10.6799 2.97787 9.53265 3.82767 7.23818 5.52728L6.23818 6.26801C4.64957 7.44476 3.85526 8.03314 3.42763 8.88208C3 9.73101 3 10.7195 3 12.6965V14C3 17.7712 3 19.6569 4.17157 20.8284C5.34315 22 7.22876 22 11 22Z" />
    <path d="M9 15C9 14.0681 9 13.6022 9.15224 13.2346C9.35523 12.7446 9.74458 12.3552 10.2346 12.1522C10.6022 12 11.0681 12 12 12V12C12.9319 12 13.3978 12 13.7654 12.1522C14.2554 12.3552 14.6448 12.7446 14.8478 13.2346C15 13.6022 15 14.0681 15 15V22H9V15Z" />
  </svg>
);
